var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestServiceBase, RestResult } from '@ane/core/lib/services/RestServiceBase';
import { WPSProxyConverter } from '@ane/core/lib/services/WPSProxy';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
class MockResult extends RestResult {
    constructor(data, error) {
        super(data, '', 0);
        this._mockData = null;
        this._mockError = '';
        this._mockData = data;
        this._mockError = error;
    }
    ensureSuccess() {
        if (!this.isSuccessful()) {
            throw new Error(`The result wasn't successful: ${this._mockError}`);
        }
    }
    getSuccessData() {
        this.ensureSuccess();
        return this._mockData;
    }
    isSuccessful() {
        return !this._mockError;
    }
}
const getErrorMessage = (result) => {
    var _a;
    if (200 !== result.statusCode) {
        return (_a = result.errorContext) === null || _a === void 0 ? void 0 : _a.displayError;
    }
    else {
        return '';
    }
};
let ComputeResource = class ComputeResource extends RestServiceBase {
    constructor() {
        super(EnvironmentService.endpoints.cms);
    }
    getComputeList(workspaceId, search) {
        return __awaiter(this, void 0, void 0, function* () {
            let address = `/workspaces/${workspaceId}/compute/query`;
            if (!!search) {
                address = `/workspaces/${workspaceId}/compute/query?filter=${search}`;
            }
            const result = yield this._get(address);
            return result;
        });
    }
    getCompute(workspaceId, name) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = `/workspaces/${workspaceId}/compute/${name}`;
            const result = yield this._get(address);
            result.error = getErrorMessage(result);
            return result;
        });
    }
    postCompute(postParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = `/workspaces/${postParams.workspaceId}/compute`;
            const result = yield this._post(postParams, address);
            result.error = getErrorMessage(result);
            return result;
        });
    }
    putCompute(postParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = `/workspaces/${postParams.workspaceId}/compute`;
            const result = yield this._put(postParams, address);
            result.error = getErrorMessage(result);
            return result;
        });
    }
    deleteCompute(workspaceId, name) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = `/workspaces/${workspaceId}/compute/${name}`;
            const result = yield this._delete(address);
            result.error = getErrorMessage(result);
            return result;
        });
    }
    postValidate(workspaceId, name) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.getCompute(workspaceId, name);
            const result = yield this.putCompute(data.getSuccessData().config);
            result.error = getErrorMessage(result);
            return result;
        });
    }
    mockCall(data, error) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = new MockResult(data, error);
            return result;
        });
    }
};
ComputeResource = __decorate([
    WPSProxyConverter()
], ComputeResource);
export default new ComputeResource();

//# sourceMappingURL=Compute.resource.js.map
